import { render, staticRenderFns } from "./LiveStream.vue?vue&type=template&id=43b5854f&scoped=true&"
import script from "./LiveStream.vue?vue&type=script&lang=ts&"
export * from "./LiveStream.vue?vue&type=script&lang=ts&"
import style0 from "./LiveStream.vue?vue&type=style&index=0&id=43b5854f&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b5854f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
